module.exports = __webpack_public_path__ + "img/研学课程.7993f345.jpg";